import './SliderCard.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {resizeImage} from "../../../utils/resizeImage";
import {generateImageMediaUrl} from "../../../utils/generateMediaUrl";
import {priceWithCommas} from "../../../utils/helperFunctions";
import {DramIcon} from "../../../assets/images";
import {Link} from "react-router-dom";
import { getUrlWithLocal } from "../../../utils/getUrlWithLocal";

function SliderCard(props) {
    const {areas,staticTexts} = props

    return <div className={'SliderCard'} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(getUrlWithLocal(`/floor/${areas?.floor?.number}/place/${areas?.number}`), '_self')
    }}>
        <div className={'badges'}>
            {areas?.bestOffer && <div className={'badge isExclusive'}>{staticTexts?.card_badge}</div>}
            <div className={'badge'} style={{backgroundColor: areas?.badge?.color}}>
                {areas?.badge?.title}
            </div>
        </div>
        <div className={'card-img'}>
            <img src={resizeImage(generateImageMediaUrl(areas?.mediaMain?.path))} alt=""/>
        </div>
        <div className={'card-number'}>
            {staticTexts?.card_number_text} № {areas.areaNumber}
        </div>
        <div className={'building-info'}>
            <span className={'square'}>
                {staticTexts?.card_square} — {areas?.area} {staticTexts?.measurement_unit_meter}<sup>2</sup>
            </span> •
            <span className={'flore'}>
                {staticTexts?.card_floor} {areas?.floor?.number}
            </span> {areas?.roomsCount && "•"}
            {
                areas?.roomsCount && <span className={'room'}>
                 {staticTexts?.card_room} {areas?.roomsCount}
            </span>
            }
        </div>
        <div className={'more-price'}>
            {areas?.price ?
                <div className={'card-price'}>{staticTexts?.filter_from} {priceWithCommas(areas?.price)} <DramIcon/>
                </div> : ''}
            <Link to={getUrlWithLocal(`/floor/${areas?.floor?.number}/place/${areas?.number}`)} target={'_self'}
                  className={'more-info'}>
                >
            </Link>
        </div>
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SliderCard);
